import type { LoanFeatures } from '../types/LoanFeatures';
import { gatekeeperFlags as AT } from './AT';
import { gatekeeperFlags as CZ } from './CZ';
import { gatekeeperFlags as HR } from './HR';
import { gatekeeperFlags as HU } from './HU';
import { gatekeeperFlags as RO } from './RO';
import { gatekeeperFlags as SK } from './SK';
import { gatekeeperFlags as RS } from './RS';

export const gatekeeperFlags: Record<string, LoanFeatures> = { AT, CZ, HR, HU, RO, SK, RS };
